/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2025 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { ConfigurationPrintOptionDto, VariantDto } from '@/api-sdk';
import { createContext } from '@lit/context';

export interface VisualDesignerContextType {
  productId: string;
  productName: string;
  variant?: VariantDto | null;
  selectedPrintOptions?: ConfigurationPrintOptionDto[] | null;
}

export const visualDesigner = {
  context: createContext<VisualDesignerContextType>(Symbol('ComponentContext')),
};
